export const Monogram = ({ className = "h-10 w-10", stroke = "#A84036", text = "#2C2623" }) => (
  <svg
    viewBox="0 0 64 64"
    className={className}
    fill="none"
    role="img"
    aria-label="Monogramme Morgane et Bruno"
  >
    <circle cx="32" cy="32" r="30" stroke={stroke} strokeWidth="1.5" />
    <circle cx="32" cy="32" r="25.5" stroke={stroke} strokeWidth="0.6" opacity="0.5" />
    <text
      x="32"
      y="39.5"
      textAnchor="middle"
      fontFamily="'Cormorant Garamond', Georgia, serif"
      fontSize="20"
      fontWeight="600"
      fill={text}
    >
      M&amp;B
    </text>
  </svg>
);

export default Monogram;
